var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('H1',[_vm._v("There is no such page on this site")]),_c('div',[_vm._v(" "+_vm._s(_vm.$route.params.pathMatch)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }